export default __webpack_public_path__ + "static/media/face_2_60.fa897d37.png";